/**
 * This set off polyfill will give you extra 200kb to the compiled file
 * (if you use all of them)
 */

// import "core-js/features/symbol"
// import "core-js/features/array/from"
// import "@babel/polyfill"
import "core-js/stable"
// import "regenerator-runtime/runtime"
// import "isomorphic-fetch"
// import es6promise from "es6-promise"
// import "core-js/features/map"
// import "core-js/features/array/find"

// es6promise.polyfill()
